import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  inject,
  input,
  output,
} from '@angular/core';

@Directive({ selector: '[recrewtSelectable]' })
export class SelectableDirective implements OnInit {
  protected el = inject(ElementRef);
  renderer = inject(Renderer2);

  public readonly value = input<unknown>();

  public readonly applyToChildWithId = input<string>();

  public readonly selected = output<unknown>();

  public readonly deselected = output<unknown>();

  private isSelected = false;

  private element!: HTMLElement;

  ngOnInit() {
    const applyToChildWithId = this.applyToChildWithId();
    // Fall back to the host when the child class is absent — querySelector may return null.
    this.element =
      (applyToChildWithId && this.el.nativeElement.querySelector(`.${applyToChildWithId}`)) ||
      this.el.nativeElement;
    this.renderer.addClass(this.element, 'mat-elevation-z3');
    this.renderer.setStyle(this.element, 'cursor', 'pointer');
    this.renderer.setStyle(this.element, 'transition', 'background-color 0.2s ease-in-out');
  }

  @HostListener('click', ['$event'])
  onClick() {
    if (!this.isSelected) {
      this.isSelected = true;
      // Deliberate neutral selection tint — theming contract has no selection variable yet.
      this.renderer.setStyle(this.element, 'background-color', 'lightgray');
      this.renderer.removeClass(this.element, 'mat-elevation-z3');
      this.renderer.addClass(this.element, 'mat-elevation-z1');
      this.selected.emit(this.value());
    } else {
      this.isSelected = false;
      this.renderer.setStyle(this.element, 'background-color', null);
      this.renderer.addClass(this.element, 'mat-elevation-z3');
      this.renderer.addClass(this.element, 'surface');
      this.renderer.removeClass(this.element, 'mat-elevation-z1');
      this.deselected.emit(this.value());
    }
  }
}
